import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-visualizer-results',
  templateUrl: './data-visualizer-results.component.html',
  styleUrls: ['./data-visualizer-results.component.scss']
})
export class DataVisualizerResultsComponent implements OnInit {
    headers: string[] =
    [
        'Assessment.Name',
        'Coach.Name',
        'Purchase.Date'
    ];

    data: any = [
        {
            assessment: "Assessment 1",
            coach: "Coach 1",
            date: "01/01/2018"
        },
        {
            assessment: "Assessment 2",
            coach: "Coach 2",
            date: "02/01/2018"
        },
        {
            assessment: "Assessment 3",
            coach: "Coach 3",
            date: "03/01/2018"
        }
    ]; 

  constructor() { }

  ngOnInit() {
  }

}
